import {
  getTechUsersByCustomer,
  getCustomers,
  newCustomer,
  updateCustomer,
  deleteCustomer,
  stateCustomer
} from '@/api/api.js';
import { log } from '@/constants.js';

export const state = {
  headers: [
    {
      text: 'CRM ID',
      align: 'start',
      sortable: false,
      value: 'crm_id'
    },
    { text: 'Ragione Sociale', value: 'ragione_sociale' },
    { text: 'Customer Description', value: 'c_description' },
    { text: 'Account Type', value: 'account_type' },
    { text: 'State', value: 'state', sortable: false },
    { text: 'Actions', value: 'actions', sortable: false, width: 130 }
  ],
  crm_id: '',
  customers: [],
  isModifingCustomer: false,
  editCustomer: false,
  linkService: false
};

export const mutations = {
  EDIT_CUSTOMER_CHANGED(state, edit) {
    state.editCustomer = edit;
  },
  LINK_SERVICE_CHANGED(state, edit) {
    state.linkService = edit;
  },
  GET_CUSTOMERS(state, customersArray) {
    state.customers = customersArray;
  },
  NEW_CUSTOMER(state, customerToAdd) {
    state.customers.push(customerToAdd.data.createCustomer);
  },
  UPDATE_CUSTOMER(state, customer) {
    state.customers.forEach(element => {
      if (element.crm_id == customer.data.updateCustomer.crm_id) {
        element.ragione_sociale = customer.data.updateCustomer.ragione_sociale;
        element.c_description = customer.data.updateCustomer.c_description;
        element.account_type = customer.data.updateCustomer.account_type;
        element.timezone = customer.data.updateCustomer.timezone;
        element.webhook_url = customer.data.updateCustomer.webhook_url;
      }
    });
  },
  DELETE_CUSTOMER(state, delete_crm_id) {
    state.customers.forEach(element => {
      if (element.crm_id == delete_crm_id) {
        const index = state.customers.indexOf(element);
        state.customers.splice(index, 1);
      }
    });
  },
  SWITCH_CUSTOMER_STATE(state, index) {
    state.customers[index].state = !state.customer[index].state;
  }
};

export const actions = {
  changeEditCustomer({ commit }, edit) {
    commit('EDIT_CUSTOMER_CHANGED', edit);
  },
  changeLinkService({ commit }, edit) {
    commit('LINK_SERVICE_CHANGED', edit);
  },

  async storeCustomers({ commit, dispatch }) {
    try {
      const customers = await getCustomers();
      commit('GET_CUSTOMERS', customers.data.listCustomers);
    } catch (err) {
      dispatch(
        'storeToastMessage',
        {
          text: 'storeCustomers',
          errObj: err,
          type: 'danger'
        },
        { root: true }
      );
    }
  },

  async storeNewCustomer({ commit, dispatch }, customer) {
    try {
      const customerToAdd = await newCustomer(
        customer.crm_id,
        customer.ragione_sociale,
        customer.c_description,
        customer.state,
        customer.account_type,
        customer.timezone,
        customer.webhook_url
      );
      dispatch(
        'storeToastMessage',
        {
          text: 'customer created',
          type: 'success'
        },
        { root: true }
      );
      commit('NEW_CUSTOMER', customerToAdd);
    } catch (err) {
      dispatch(
        'storeToastMessage',
        {
          text: 'storeNewCustomer',
          errObj: err,
          type: 'danger'
        },
        { root: true }
      );
      throw false;
    }
  },

  async storeUpdatedCustomer({ dispatch, commit }, customer) {
    try {
      const customerToUpdate = await updateCustomer(
        customer.crm_id,
        customer.ragione_sociale,
        customer.c_description,
        customer.account_type,
        customer.timezone,
        customer.webhook_url
      );
      dispatch(
        'storeToastMessage',
        {
          text: 'customer updated',
          type: 'success'
        },
        { root: true }
      );
      commit('UPDATE_CUSTOMER', customerToUpdate);
    } catch (err) {
      dispatch(
        'storeToastMessage',
        {
          text: 'storeUpdatedCustomer',
          errObj: err,
          type: 'danger'
        },
        { root: true }
      );
    }
  },

  async deleteTableCustomer({ dispatch, commit }, crm_id) {
    try {
      const tech_users = await getTechUsersByCustomer(crm_id);
      const containsApiUsers =
        tech_users.data.listTechUsersByCustomer.length > 0;

      if (!containsApiUsers) {
        const customerToDelete = await deleteCustomer(crm_id);
        dispatch(
          'storeToastMessage',
          {
            text: 'customer deleted',
            type: 'success'
          },
          { root: true }
        );
        commit('DELETE_CUSTOMER', customerToDelete.data.deleteCustomer.crm_id);
      } else {
        log.error('Error, customer contains user api');
        dispatch(
          'storeToastMessage',
          {
            text: 'This customer contains user api. Delete them to continue',
            type: 'warning'
          },
          { root: true }
        );
      }
    } catch (err) {
      dispatch(
        'storeToastMessage',
        {
          text: 'createWorkspaceServiceAction',
          errObj: err,
          type: 'danger'
        },
        { root: true }
      );
    }
  },
  async switchCustomerState({ dispatch }, selected) {
    if (selected.length > 0) {
      for await (const item of selected) {
        try {
          await stateCustomer(item.crm_id, !item.state);
        } catch (err) {
          dispatch(
            'storeToastMessage',
            {
              text: 'switchCustomerState',
              errObj: err,
              type: 'danger'
            },
            { root: true }
          );
        }
      }

      dispatch(
        'storeToastMessage',
        {
          text: 'Customer state switched',
          type: 'success'
        },
        { root: true }
      );
    } else {
      dispatch(
        'storeToastMessage',
        {
          text: 'Please select one or more Customers',
          type: 'warning'
        },
        { root: true }
      );
    }
  }
};

export const getters = {};
